//react
import React from 'react';
//components
import CustomSwitch from '../common/custom-switch';
//style
import useStyles from './PrinterSettings.styles';

const PrinterSettings = ({
  automaticPrinterTitle,
  automaticPrinterDescription,
  isActive,
  onChange,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.flexContainer}>
        <div className={classes.primaryDescriptionFonts}>
          {automaticPrinterTitle}
          <div className={classes.secondaryDescriptionFonts}>
            {automaticPrinterDescription}
          </div>
        </div>
        <div className={classes.alignSwitchMobile}>
          <CustomSwitch
            checked={isActive}
            onChange={async e => {
              const { checked } = e.target;
              await onChange(checked);
            }}
          />
        </div>
      </div>
    </div>
  );
};

PrinterSettings.defaultProps = {
  classes: {},
};
export default PrinterSettings;
